import withEffects, { scrollToTop } from './withEffects'
import { compose } from 'redux'

export { scrollToTop }

export default compose(withEffects)(() => null)
